import React from 'react'
import { ModulePanel, ModuleHeader, ModuleBody, ModuleFooter } from 'containers/purchase/modules/module_panel'
import TicketTypesList from 'containers/purchase/modules/ticket_types_module/ticket_types_list'
import { useTranslation } from 'react-i18next'

const TicketTypesModule = (props) => {
  const { config, machine, status, type = 'event_ticket', resSize } = props
  const { t, i18n } = useTranslation()
  const [current, send] = machine
  const { tickets, event } = current.context

  const maxTicketsReservation = config?.product?.external_api_config?.max_tickets_reservation
  const maxAvailability = event && event.availability

  const qtyTickets = () =>
    tickets.map((ticket) => ticket.qty).reduce((accum, current) => accum + current, 0)

  const TicketHeader = () => {
    return (
      <span>
        <i className="fas fa-ticket-alt me-2" aria-hidden="true"></i>
        {status === 'completed'
          ? i18n.t('ticket_types_module.selected_tickets', { qty: qtyTickets() })
          : i18n.t('ticket_types_module.select_ticket_types')}
      </span>
    )
  }

  const VehicleHeader = () => {
    return (
      <span>
        <i className="fa fa-taxi me-2" aria-hidden="true"></i>
        {status === 'completed'
          ? i18n.t('ticket_types_module.selected_vehicles', { qty: qtyTickets() })
          : i18n.t('ticket_types_module.select_vehicles')}
      </span>
    )
  }

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() => (status === 'completed' ? send('REOPEN_TICKETSSTEP') : null)}
      >
        {type === 'vehicle' ? <VehicleHeader /> : <TicketHeader />}
      </ModuleHeader>
      <ModuleBody status={status} className={' '}>
        <TicketTypesList
          type={type}
          data={tickets}
          maxQtyReservation={maxTicketsReservation || maxAvailability}
          resSize={resSize}
          onTicketQtyChanged={(tickets) =>
            send({ type: 'TICKETS_SELECTION', tickets })
          }
        />
      </ModuleBody>
      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

export default TicketTypesModule
